import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';

import { CartContext } from '../../contexts/cart.context';
import { formatViewNumber } from '../../utils/utils';
import Button from '../button/button.component';
import CartItem from '../cart-item/cart-item.component';
import './cart-dropdown.styles.scss';

const CartDropdown = () => {
  const { cartItems, cartTotal } = useContext(CartContext);
  const navigate = useNavigate();

  const goToCheckoutHandler = () => {
    navigate('/checkout');
  };

  const isEmpty = cartItems.length === 0;

  return (
    <div className="cart-dropdown">
      <p className="cart-dropdown-title">
        Panier{!isEmpty && ` (${cartItems.length})`}
      </p>

      {isEmpty ? (
        <p className="cart-dropdown-empty">Votre panier est vide.</p>
      ) : (
        <>
          <div className="cart-dropdown-items">
            {cartItems.map((item) => (
              <CartItem key={item.id} cartItem={item} />
            ))}
          </div>

          <div className="cart-dropdown-total">
            <span className="cart-dropdown-total-label">Total</span>
            <span className="cart-dropdown-total-value">
              {formatViewNumber(cartTotal)} €
            </span>
          </div>

          <Button onClick={goToCheckoutHandler}>Voir le panier</Button>
        </>
      )}
    </div>
  );
};

export default CartDropdown;
